import {i18n} from "@/plugins/i18n";
import { fieldTypes } from "@/constants/CustomerFormatFieldTypes";

export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'name',
        title: i18n.t('online-factor.name'),
        sortable: false,
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('online-factor.type'),
        sortable: false,
        template: (row) => {
            return '<span dir="ltr">' + fieldTypes.find(i => i.value === row.type).fa_name + '</span>'
        },
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'fa_name',
        title: i18n.t('online-factor.fa_name'),
        sortable: true,
        width: 120,
        textAlign: 'center',
    },
]